import type { AxiosRequestConfig } from 'axios'
import api from './base'

import type { CommonResponse } from './base'
import type { UserFlag } from './user'

export type VCODE_SCENE = 'REGISTER' | 'RESET_PWD' | 'BIND_EMAIL'

export function sendVcode(
  email: string,
  scene: VCODE_SCENE,
  captchaToken: string
) {
  return api.post<unknown, CommonResponse<{ freezeSeconds: number }>>(
    '/v1/auth/vcode/email',
    {
      email,
      scene,
      captchaToken,
    }
  )
}

export function resetPwd(payload: RegisterPayload) {
  return api.post<unknown, CommonResponse<never>>(
    '/v1/auth/reset-pwd/email',
    payload
  )
}

type RegisterPayload = {
  email: string
  code: string
  password: string
}
export enum UserRole {
  AlphaCreator = 'alpha_creator',
}

export type UserInfo = {
  id: string
  nickname: string
  avatar?: string
  email?: string
  phone?: string
  phoneCountry?: string
  createdAt: string
  admin: boolean
  hasBoundWechat: boolean
  wechatInfo?: {
    nickname: string
  }
  claimedGift?: boolean
  roles: UserRole[]
  guest: boolean
  flag?: Record<UserFlag, boolean>
  terminationResponse: {
    terminationAppliedAt?: string
    willTerminateAt?: string
  }
}
export function register(payload: RegisterPayload) {
  return api.post<unknown, CommonResponse<{ token: string; user: UserInfo }>>(
    '/v1/auth/register/email',
    payload
  )
}

export function login(payload: { email: string; password: string }) {
  return api.post<
    unknown,
    CommonResponse<{
      token: string
      user: UserInfo
      terminationAppliedAt?: string
      willTerminateAt?: string
    }>
  >('/v1/auth/login', payload)
}

// token 无效时后端会返回 401
// 自动登录时需要忽略 401，不希望走 global handler
export function getCurrentUser(ignoreError = false) {
  const config: AxiosRequestConfig = {}
  if (ignoreError) {
    config.validateStatus = null
  }
  return api.get<unknown, { user: UserInfo }>('/v1/users/current', config)
}

export function wxLogin(payload: {
  code: string
  wechatType?: 'WEB' | 'APP' | 'MP' // default to "WEB" in backend
}) {
  return api.post<
    unknown,
    CommonResponse<{
      // 如果用户未注册，loginResponse 为 null
      loginResponse?: { token: string; user: UserInfo }
      wxToken: string
      wxOpenId: string
    }>
  >('/v1/auth/wechat/login', payload)
}

export function appleLogin(payload: { identityToken: string }) {
  return api.post<unknown, CommonResponse<{ token: string; user: UserInfo }>>(
    '/v1/auth/apple/login',
    payload
  )
}

export function guestLogin() {
  return api.post<unknown, CommonResponse<{ token: string; user: UserInfo }>>(
    '/v1/auth/guest/login'
  )
}

export function wxRegister(payload: { wxToken: string }) {
  return api.post<unknown, CommonResponse<{ token: string; user: UserInfo }>>(
    '/v1/auth/wechat/register',
    payload
  )
}

export function wxBind(payload: {
  email: string
  password: string
  wxToken: string
}) {
  return api.post<unknown, CommonResponse<{ token: string; user: UserInfo }>>(
    '/v1/auth/email/bind_wechat',
    payload
  )
}
